module.exports = __webpack_public_path__ + "img/shop-mockup.4deefbab.png";